import React from "react";
import Banner from "./Banner";
import StayTouch from "../../layout/StayTouch";
import AuthBanner from "../../reusable/AuthBanner";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import PricingContent from "./PricingContent";
import Global from "../../layout/Global";
class NewPricing extends React.Component {
  render() {
    return (
      <div>
        <Banner />
        <PricingContent />
        <Global type="pricing" />
        {/*<StayTouch />*/}
      </div>
    );
  }
}

export default layoutWrapper(NewPricing);



// WEBPACK FOOTER //
// ./src/pages/newpricing/index.js